var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createUrl, mapResponseToJson, mapResponseToText, serializeCookie } from '@atlassiansox/asc-core';
import { fetch } from 'cross-fetch';
export const DEFAULT_BASE_URL = 'https://hamlet.atlassian.com';
/**
 * @see: https://hello.atlassian.net/wiki/spaces/HAMS/pages/127995591/Hamlet+API
 */
export class HamletClient {
    constructor({ baseUrl = DEFAULT_BASE_URL } = {}) {
        this.baseUrl = baseUrl;
    }
    getXsrfToken({ cloudSessionTokenCookie }) {
        return __awaiter(this, void 0, void 0, function* () {
            return mapResponseToText(yield fetch(`${this.baseUrl}/1.0/auth/xsrf/plain`, {
                headers: {
                    cookie: serializeCookie(cloudSessionTokenCookie)
                }
            }));
        });
    }
    getEmailExists({ email }) {
        return __awaiter(this, void 0, void 0, function* () {
            return mapResponseToJson(yield fetch(`${this.baseUrl}/1.0/public/aid/exists/${email}`, {
                method: 'POST'
            }));
        });
    }
    getCart({ cartId }) {
        return __awaiter(this, void 0, void 0, function* () {
            return mapResponseToJson(yield fetch(`${this.baseUrl}/1.0/public/order/cart/${cartId}`));
        });
    }
    patchUser({ cloudSessionTokenCookie, firstName, lastName }) {
        return __awaiter(this, void 0, void 0, function* () {
            return mapResponseToJson(yield fetch(`${this.baseUrl}/1.0/public/contact/currentUser/patch`, {
                method: 'PATCH',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'ATL-XSRF-Token': yield this.getXsrfToken({
                        cloudSessionTokenCookie
                    }),
                    'Cookie': serializeCookie(cloudSessionTokenCookie)
                },
                body: JSON.stringify([
                    {
                        op: 'replace',
                        path: '/contactDetails/firstName',
                        value: firstName
                    },
                    {
                        op: 'replace',
                        path: '/contactDetails/lastName',
                        value: lastName
                    }
                ])
            }));
        });
    }
    getProductPricing({ productKeys, licenseType = 'evaluation', requestingApplication = 'WAC', monthsValid = '1' }) {
        return __awaiter(this, void 0, void 0, function* () {
            return mapResponseToJson(yield fetch(createUrl({
                baseUrl: this.baseUrl,
                path: `/1.0/public/pricing/query`,
                query: {
                    licenseType,
                    productKey: productKeys,
                    requestingApplication,
                    monthsValid,
                    cacheBuster: Date.now()
                }
            })));
        });
    }
}
//# sourceMappingURL=hamlet-client.js.map